/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import { bus } from '@/main';
import root from '@/_helpers/roots';
import toast from '@/services/toast';
import updatePpDetails from '../../update-paperpile-details';
let paperUploadFromLocal = root.pdfPaperPileApiUrl.link;

export default {
  name: 'add-paper-from-local',
  components: {
    'update-pp-details' : updatePpDetails
  },
  props: [],
  data () {
    return {
      submitted:false,
      file:null,
      uploadAttachmentName:'',
      topic:'',
      updatePaperPileDetailPopupState:false,
      paperUpdateInfo:null,
      encryptedToggle:false,
      pdf_password:'',
      passwordIncorrectState:false,
      uploadProgress:0
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('updatePaperPileDetailPopupStateBus', (data) => {
      this.updatePaperPileDetailPopupState = data;
    });
  },
  methods: {
    updatePpDetailMethod(data){
      this.paperUpdateInfo = data
      this.updatePaperPileDetailPopupState = true
      $('body').addClass('body_right_scroll_remove')  
    },
    getPaperPileListAgain(){
      this.$store.dispatch('getAllPaperPileFun')
    },
    handleAttachmentUpload(event) {
      var input = event.target;
      var reader = new FileReader();
      var _self = this
      reader.onload = function (event) {
          var contents = event.target.result;
          if (contents.indexOf('/Encrypt') !== -1) {
            _self.encryptedToggle = true
          } else {
            _self.encryptedToggle = false
          }
      };
      reader.readAsText(input.files[0]);
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }  else {
        this.uploadAttachmentName = '';
      }
    },
    createPaperpileBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('file', this.file);
          formData.append('title', this.topic);
          formData.append('file_name', this.uploadAttachmentName);
          formData.append('is_favourite', false);
          if(this.pdf_password != ''){
            formData.append('pdf_password', this.pdf_password);
          }
          axios.post(paperUploadFromLocal, formData, {
            onUploadProgress: progressEvent => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
            },
          }).then((res) => {  
              this.file = null
              this.topic = ''
              this.$validator.reset()
              toast.success(res.data.msg);
              this.getPaperPileListAgain()
              bus.$emit('paperSelectedBus', res.data.data.id);
              this.updatePpDetailMethod(res.data.data);
              this.uploadProgress = 0
              this.submitted =  false
            }).catch((err) => {
              if(err.status == '406'){
                this.uploadProgress = 0
                this.submitted =  false
                toast.error('The pdf file already exists');
                bus.$emit('paperSelectedBus', err.data.data.id);
                this.closeCreatePaperpilePopup()
              }else if(err.status == '409'){
                this.uploadProgress = 0
                this.passwordIncorrectState = true
                this.submitted =  false
                toast.error('PDF Password Incorrected');
              }else{
                this.submitted =  false
                toast.error(err.data.user_msg || err.data.msg);
              }
            })
          return;
        }
      })
    },
    closeCreatePaperpilePopup(){
      bus.$emit('addPaperPilePopupStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
    keymonitor(){
      if( this.passwordIncorrectState == true){
        this.passwordIncorrectState = false
      }
    }
  }
}


